import React, { useState, useEffect } from 'react';

import { SingleInput, SingleText } from '../../Res/BaseInput';
import { RespCustomerContract_CustomerInformation } from '../../../../item/ItemCustomerContract';

export function ItemCustomerInformation({ item, action, isEdit = true }) {
  const [customerInformation, setCustomerInformation] = useState("")
  const [companyName, setCompanyName] = useState("")
  const [texIdNumber, setTexIdNumber] = useState("")
  const [companyAddress, setCompanyAddress] = useState("")

  useEffect(() => {
    if (item !== undefined && customerInformation !== item) {
      setCustomerInformation(item)
      setCompanyName(item.companyName)
      setTexIdNumber(item.texIdNumber)
      setCompanyAddress(item.companyAddress)
    }
  }, [item])

  useEffect(() => {
    if (action !== undefined) {
      var mRespCustomerContract_CustomerInformation = new RespCustomerContract_CustomerInformation({
        companyName,
        texIdNumber,
        companyAddress
      })
      action(mRespCustomerContract_CustomerInformation)
    }
  }, [companyName, texIdNumber, companyAddress, action])


  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>事業單位資訊</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {isEdit ?
            <SingleInput title={"公司名稱"} val={companyName} action={setCompanyName} placeholder={"XX股份有限公司"} />
            : <SingleText title={"公司名稱"} val={companyName} />
          }
          {isEdit ?
            <SingleInput title={"公司統編"} val={texIdNumber} action={setTexIdNumber} placeholder={"29178151"} />
            : <SingleText title={"公司統編"} val={texIdNumber} />
          }
          {isEdit ?
            <SingleInput title={"公司地址"} val={companyAddress} action={setCompanyAddress} placeholder={"新北市五股區五工三路78號"} />
            : <SingleText title={"公司地址"} val={companyAddress} />
          }
        </div>
      </div>
    </>
  )
}